import { HeaderItem } from '@/components/Header/types';

export const createRel = (item?: HeaderItem) => {
  return `noopener noreferer ${item?.notIndexed ? 'nofollow' : ''}`;
};
